import React from 'react';
import { SectionReveal } from '../components/SectionReveal';
export function BenefitsSection() {
  return <section className="relative w-full bg-brand-mid py-20 md:py-28 overflow-hidden" data-id="element-31">
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-blue-500/30 to-transparent" data-id="element-32" />

      <div className="relative z-10 max-w-4xl mx-auto px-4" data-id="element-33">
        <SectionReveal data-id="element-34">
          <p className="text-4xl mb-4 text-center" data-id="element-35">🎯</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-white text-center mb-14 uppercase tracking-[-0.02em]" data-id="element-36">
            Lo que vas a lograr con la guía
          </h2>
        </SectionReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-37">
          <SectionReveal delay={0.1} data-id="element-38">
            <div className="bg-brand-darker/80 border border-blue-500/15 rounded-xl p-8 text-center h-full" data-id="element-39">
              <div className="w-16 h-16 bg-blue-500/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-40">
                <span className="text-3xl" data-id="element-41">💰</span>
              </div>
              <p className="text-lg sm:text-xl text-white font-body font-semibold leading-relaxed" data-id="element-42">
                Recuperás la inversión en tu próxima factura
              </p>
            </div>
          </SectionReveal>

          <SectionReveal delay={0.2} data-id="element-43">
            <div className="bg-brand-darker/80 border border-blue-500/15 rounded-xl p-8 text-center h-full" data-id="element-44">
              <div className="w-16 h-16 bg-blue-500/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-45">
                <span className="text-3xl" data-id="element-46">📈</span>
              </div>
              <p className="text-lg sm:text-xl text-white font-body font-semibold leading-relaxed" data-id="element-47">
                Ahorrás todos los meses
              </p>
            </div>
          </SectionReveal>

          <SectionReveal delay={0.3} data-id="element-48">
            <div className="bg-brand-darker/80 border border-blue-500/15 rounded-xl p-8 text-center h-full" data-id="element-49">
              <div className="w-16 h-16 bg-blue-500/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-50">
                <span className="text-3xl" data-id="element-51">🏠</span>
              </div>
              <p className="text-lg sm:text-xl text-white font-body font-semibold leading-relaxed" data-id="element-52">
                Aplicable en cualquier hogar de Argentina
              </p>
            </div>
          </SectionReveal>

          <SectionReveal delay={0.4} data-id="element-53">
            <div className="bg-brand-darker/80 border border-blue-500/15 rounded-xl p-8 text-center h-full" data-id="element-54">
              <div className="w-16 h-16 bg-blue-500/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-55">
                <span className="text-3xl" data-id="element-56">⚡</span>
              </div>
              <p className="text-lg sm:text-xl text-white font-body font-semibold leading-relaxed" data-id="element-57">
                Cambios simples que notás desde el primer mes
              </p>
            </div>
          </SectionReveal>
        </div>
      </div>
    </section>;
}